import React from "react";

const CardCatalogoSmall = ({
    producto,
    onVerDetallesClick,
    onAgregarClick,
    onCotizarClick,
}) => {
    const { id, imagenes = [], nombre, precio } = producto;

    return (
        // Se ajustan las columnas para mostrar más tarjetas en pantallas grandes y medianas.
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">
            <div className="card h-100 shadow-sm border-0 rounded-lg overflow-hidden">
                {/* Lógica de la imagen */}
                <div className="card-img-top position-relative d-flex justify-content-center align-items-center bg-light" style={{ height: "180px" }}>
                    {imagenes.length > 0 ? (
                        <img src={imagenes[0]} className="img-fluid" alt={nombre} style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                    ) : (
                        <img src="/productos.jpg" className="img-fluid" alt={nombre} style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                    )}
                </div>

                <div className="card-body d-flex flex-column p-2 text-center">
                    <h6 className="card-title text-truncate mb-1" style={{ fontSize: "0.9rem" }}>{nombre}</h6>
                    <p className="card-text fw-bold mb-2" style={{ fontSize: "1.1rem" }}>L {precio}</p>
                    <div className="d-flex justify-content-center gap-1 mt-auto">
                        <button
                            onClick={() => onAgregarClick(producto)}
                            className="btn btn-dark btn-sm rounded-pill"
                            title="Agregar al carrito"
                        >
                            <i className="fas fa-cart-plus"></i>
                        </button>
                        <button
                            onClick={() => onVerDetallesClick(producto)}
                            className="btn btn-outline-secondary btn-sm rounded-pill mx-2"
                            title="Ver más"
                        >
                            <i className="fas fa-eye"></i>
                        </button>
                        {onCotizarClick && (
                            <button
                                onClick={() => onCotizarClick(producto)}
                                className="btn btn-primary btn-sm rounded-pill"
                                title="Cotizar"
                            >
                                <i className="fas fa-file-invoice"></i>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardCatalogoSmall;